import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { CurrentAdminItemPayload } from '@modules/groups-of-admins/submodules/edit/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { GROUPS_OF_ADMINS_PERMISSIONS } from '@modules/groups-of-admins/constants';
import {
  OWNERS_LIST_QUERY_API_URL,
  OWNERS_LIST_QUERY_KEY,
} from '@modules/groups-of-admins/submodules/edit/constants';

export default function useCurrentAdminOwnerDataQuery(id: ComputedRef<number | undefined>): IContextQueryResult<CurrentAdminItemPayload, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery<CurrentAdminItemPayload, Error>({
    queryKey: [OWNERS_LIST_QUERY_KEY, id],
    queryFn: ({ signal }) => fetchGet<CurrentAdminItemPayload>(OWNERS_LIST_QUERY_API_URL, {
      signal,
      permission: GROUPS_OF_ADMINS_PERMISSIONS.EDIT,
      urlParams: {
        id: id.value,
      },
    }),
    enabled: computed(() => !!id.value),
  });
}
